var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserGreenReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 153,
    viewBox: "0 0 154 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.828 81.2837C114.667 73.1201 121.689 60.149 121.689 45.5664C121.689 20.9261 101.642 0.878906 77.0001 0.878906C52.3597 0.878906 32.3126 20.9261 32.3126 45.5664C32.3126 60.149 39.3329 73.1201 50.1721 81.2837C21.151 92.1769 0.439453 120.208 0.439453 152.988H14.2676C14.2676 118.396 42.41 90.2558 77.0019 90.2558C111.592 90.2558 139.734 118.396 139.734 152.988H153.563C153.561 120.208 132.851 92.1769 103.828 81.2837ZM46.1407 45.5664C46.1407 28.5496 59.9832 14.707 77.0001 14.707C94.017 14.707 107.859 28.5496 107.859 45.5664C107.859 62.5833 94.017 76.4276 77.0001 76.4276C59.9832 76.4276 46.1407 62.5833 46.1407 45.5664Z",
    fill: "#E5F3ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGreenReport);
export default __webpack_public_path__ + "static/media/user-green-report.5b3308a97e9ed9b95aeb802666f7d1c0.svg";
export { ForwardRef as ReactComponent };